export const  customer ={
  'zh-CN': {
    allCustomers: '全部',
    exclusiveCustomers: '独占客户',
    dealCustomers: '成单客户',
    sharedCustomers: '共享客户',
    afterSalesCustomers: '售后服务客户',
    moveToMember: '移至成员',
    moveToShared: '移至共享',
    grabAsExclusive: '抢为独占',
    searchByPhoneName: '请输入电话、姓名或微信号',
    searchByEmployee: '请输入员工名称',
    search: '查询',
    labelFilter: '标签筛选',
    serialNumber: '序号',
    name: '姓名',
    phoneNumber: '手机号码',
    email: '邮箱',
    wechatId: '微信号',
    inputTime: '录入时间',
    label: '',
    dealAmount: '成交金额',
    operation: '操作',
    details: '详情',
    edit: '编辑',
    customerList: '客户列表',
    filterLabelGroup: '筛选标签组',
    reset: '重置',
    confirm: '确定',
    wechatChatStatistics: '与客户企微聊天统计',
    yesterday: '昨日',
    last7Days: '近七日',
    last30Days: '近30日',
    startDate: '开始日期',
    endDate: '结束日期',
    singleChatTotal: '单聊总数',
    sentMessageCount: '发送消息数',
    sentRedPacketCount: '发送红包数',
    sentRedPacketAmount: '发送红包金额',
    repliedChatRatio: '已回复聊天占比',
    averageFirstReplyTime: '平均首次回复时长',
    createTime: '创建时间',
    enterprise: '企业',
    description: '描述',
    source: '来源',
    mallSection: '商城版块',
    appointmentSection: '预约版块',
    dynamicSection: '动态版块',
    uploadImage: '上传图片',
    uploadTip: '上传图片的最佳尺寸：690*300像素，其他尺寸会影响页面效果，格式png，jpeg，jpg。大小不超过2M，最少上传1张最多可上传6张',
    save: '保存',
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    settingSuccess: '设置成功',
    customerName: '客户姓名',
    customerPhone: '客户电话',
    customerEmail: '客户邮箱',
    customerAddress: '客户地址',
    customerStatus: '客户状态',
    customerSource: '客户来源',
    customerLevel: '客户等级',
    addCustomer: '添加客户',
    editCustomer: '编辑客户',
    deleteCustomer: '删除客户',
    searchCustomer: '搜索客户',
    exportCustomer: '导出客户',
    importCustomer: '导入客户',
    name: '姓名',
    phone: '手机号',
    wechat: '微信号',
    companyWechat: '企业微信',
    email: '邮箱',
    position: '职位',
    company: '公司',
    remark: '备注',
    tags: '标签',
    addTag: '添加标签',
    editTag: '编辑标签',
    addTagGroup: '添加标签组',
    editTagGroup: '编辑标签组',
    tagGroupName: '标签组名称',
    subTag: '子标签',
    addSubTag: '添加子标签',
    addTagGroupBtn: '添加标签组',
    reset: '重置',
    confirm: '确定',
    cancel: '取消',
    delete: '删除',
    save: '保存',
    inputName: '请输入姓名',
    inputPhone: '请输入手机或座机号码',
    inputWechat: '请输入微信号',
    inputCompanyWechat: '请输入企业微信',
    inputEmail: '请输入邮箱',
    inputPosition: '请输入职位',
    inputCompany: '请输入公司名称',
    inputRemark: '请输入备注',
    inputTagGroupName: '请输入标签组名称',
    inputSubTag: '请输入子标签',
    sharedScope: '共享范围',
    exclusive: '自己独占',
    enterpriseShared: '企业共享',
    noPermissionEdit: '无权编辑',
    maxTagsWarning: '标签最多添加八个',
    maxTagGroupsWarning: '标签组最多添加三个',
    operationSuccess: '操作成功',
    pleaseEnterCustomerName: '请填写客户姓名',
    pleaseEnterCorrectPhone: '请填写正确的电话号码',
    pleaseEnterCorrectEmail: '请填写正确的邮箱',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    employeeCannotBeCustomer: '该用户是本公司的员工，不能添加为客户',
    customerOccupiedByMember: '该客户已被成员',
    contactForExclusive: '独占，请与他取得联系',
    customerExistsInPool: '共享客户池已存在该客户，前去抢为独占',
    tip: '提示',
    ok: '确定',
    customerAlreadyExclusive: '该客户已被您独占',
    noPermissionModify: '无权修改',
    moveToMember: '移至成员',
    moveToShared: '移至共享',
    grabAsExclusive: '抢为独占',
    search: '查询',
    tagFilter: '标签筛选',
    details: '详情',
    edit: '编辑',
    serialNumber: '序号',
    customerName: '客户姓名',
    mobileNumber: '手机号码',
    email: '邮箱',
    wechatId: '微信号',
    inputTime: '录入时间',
    tags: '标签',
    dealAmount: '成交金额',
    operation: '操作',
    inputPhoneNameWechat: '请输入电话、姓名或微信号',
    inputEmployeeName: '请输入员工名称',
    moveToSharedConfirm: '此操作会将客户移至共享池',
    confirmGrabAsExclusive: '是否抢为独占？',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    transferSuccess: '移交成功',
    pleaseSelectTransferMember: '请先选择移交的成员',
    syncQywxCustomer: '同步企微客户',
    followUpOverview: '跟进概况',
    people: '人',
    todayNeedFollowUp: '今日需跟进数',
    todayNeedFollowUpTip: '创建时间在一周之前并且没有成交金额的客户数，并且在最近一周都没有跟进记录的客户数。',
    accumulated7DaysNoFollow: '（累计7天未跟进）',
    todayFollowedUp: '今日已跟进数',
    todayNotFollowedUp: '今日未跟进数',
    todayNotFollowedUpTip: '属于独占客户，当天没有跟进并且没有成交金额的客户数。',
    dataAnalysis: '数据分析',
    today: '今日',
    last7Days: '近七天',
    last30Days: '近三十天',
    startDate: '开始日期',
    endDate: '结束日期',
    totalFollowCustomers: '累计跟客户数',
    totalFollowCount: '累计跟进次数',
    customerFollowUpRate: '客户跟进率',
    customerFollowUpRateTip: '今日已跟进数 / 今日需跟进数。',
    memberFollowUpList: '成员跟进列表',
    customerFollowUpList: '客户跟进列表',
    employeeName: '姓名',
    phone: '电话',
    exclusiveCustomerCount: '独占客户数',
    dealCustomerCount: '成单客户数',
    totalDealAmount: '总成交金额',
    customerTotalFollowCount: '客户总跟进次数',
    customerFollowUpRate7Days: '7日客户跟进率',
    todayNeedFollowUpCount: '今日需跟进数',
    todayFollowedUpCount: '今日已跟进数',
    todayNotFollowedUpCount: '今日未跟进数',
    details: '详情',
    inputTime: '录入时间',
    dealAmount: '成交金额',
    followCount: '跟进次数',
    lastFollowTime: '最后一次跟进时间',
    followPerson: '跟进人',
    followContent: '跟进内容',
    operation: '操作',
    search: '搜索',
    reset: '重置',
    pleaseEnterMemberNamePhone: '请输入成员姓名或电话',
    pleaseEnterPhoneNameWechat: '请输入电话、姓名或微信号',
    pleaseSelectFollowType: '请选择跟进类型',
    all: '全部',
    todayNeedFollowUpType: '今日需跟进',
    todayFollowedUpType: '今日已跟进',
    todayNotFollowedUpType: '今日未跟进',
    notFollowedUp: '未跟进',
    warning: '警告',
    pleaseSelectTransferMember: '请先选择移交的成员',
    transferSuccess: '移交成功',
    confirmGrabAsExclusive: '是否抢为独占？',
    prompt: '提示',
    confirm: '确定',
    cancel: '取消',
    edit: '编辑',
    remark: '备注',
    remarkPlaceholder: '这里是备注内容',
    followUpRecord: '跟进记录',
    viewMore: '查看更多',
    pleaseSelectFollowUpMethod: '请选择跟进方式：',
    phoneVisit: '电话拜访',
    wechatVisit: '微信拜访',
    manualAdd: '手动添加',
    faceToFaceVisit: '当面拜访',
    otherMethod: '其他方式',
    pleaseEnterFollowUpRecord: '请输入跟进记录',
    save: '保存',
    afterSalesRecord: '售后记录',
    afterSalesPersonnel: '售后服务人员：',
    transferAfterSales: '转移售后',
    set: '设置',
    dealRecord: '成交记录',
    enterDealAmount: '录入成交金额',
    pleaseEnterAmount: '请输入金额',
    pleaseEnterRemark: '请输入备注',
    uploadImage: '上传图片',
    add: '添加',
    dealAmount: '成交金额',
    submitTime: '提交时间',
    submitPerson: '提交人',
    transactionAmount: '交易金额',
    remark: '备注',
    viewMore: '查看更多',
    customerWechatData: '客户企微数据',
    wechatName: '企微姓名',
    wechatCompany: '企微企业',
    wechatPosition: '企微职位',
    wechatRemark: '企微备注',
    remarkCompanyName: '备注-公司名',
    remarkMobile: '备注-手机号码',
    remarkDescription: '备注-描述',
    remarkTags: '备注-标签',
    type: '类型',
    wechatUser: '微信用户',
    enterpriseWechatUser: '企业微信用户',
    source: '来源',
    addTime: '添加时间',
    unknownSource: '未知来源',
    scanQRCode: '扫描二维码',
    searchMobile: '搜索手机号',
    businessCardShare: '名片分享',
    groupChat: '群聊',
    mobileContacts: '手机通讯录',
    wechatContacts: '微信联系人',
    autoAddThirdPartyApp: '安装第三方应用时自动添加',
    searchEmail: '搜索邮箱',
    videoAccount: '视频号',
    scheduleParticipant: '日程参与人',
    meetingParticipant: '会议参与人',
    wechatFriendCorresponding: '微信好友对应的企业微信',
    smartHardwareExclusive: '智慧硬件专属客服',
    internalMemberSharing: '内部成员共享',
    adminManagerAssignment: '管理员/负责人分配',
    visitBusinessCard: '访问名片',
    manualAdd: '手动添加',
    referral: '转介绍',
    pendingReturnVisitImport: '待回访区导入',
    enterpriseWechat: '企业微信',
    moveToMember: '移至成员',
    grabAsExclusive: '抢为独占',
    moveToShared: '移至共享',
    transferToSharedPool: '此操作会将客户移至共享池',
    moveToSharedPoolTip: '此操作会将客户移至共享池',
    confirmGrabAsExclusive: '是否抢为独占？',
    exclusiveSuccess: '独占成功',
    pleaseSelectMember: '请先选择成员',
    transferSuccess: '移交成功',
    pleaseEnterValidAmount: '请输入有效金额',
    addSuccess: '添加成功',
    deleteSuccess: '删除成功',
    uploadLimitWarning: '最多只可上传九张图片！',
    pleaseEnterCorrectAmount: '请输入正确的金额',
    pleaseEnterFollowUpRecord: '请先输入跟进记录',
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    pleaseEnterAfterSalesRecord: '请输入售后/服务记录',
    noContentToSave: '没有可保存的内容！',
    saveSuccess: '保存成功',
    noPermissionModifyAfterSales: '无权修改该客户的售后信息',
    pleaseEnterAmount: '请输入金额',
    pleaseEnterRemark: '请输入备注',
    pleaseEnterFollowUpRecord: '请输入跟进记录',
    myFollowUpAnalysis: '我的跟进分析',
    enterpriseFollowUpAnalysis: '企业跟进分析',
    selectAfterSales: '选择售后',
    memberName: '成员名字',
    visitCount: '访问次数',
    inputCount: '输入次数',
    customerAcquisitionArticle: '获客文章',
    poster: '海报',
    distribution: '分销',
    batchImportData: '批量导入数据',
    pleaseEnterEmployeeName: '请输入员工名称',
    importData: '导入数据',
    export: '导出',
    inputCustomer: '录入客户',
    creditRecordTitle: '信用额度变动记录',
    viewCreditRecord: '查看信用记录',
    creditRecordPageTip: '点击按钮查看客户信用额度记录',
    userName: '姓名',
    customerInfoLabelRemainingCredit: '信用额度余额',
    modifyCreditTitle: '修改信用额度',
    buttonModifyCredit: '修改额度',
    tableTime: '时间',
    tableType: '类型',
    tableChangeAmount: '变动金额',
    tableBalanceBefore: '变动前余额',
    tableBalanceAfter: '变动后余额',
    tableRelatedOrder: '关联订单',
    tableRemark: '备注',
    changeAmountLabel: '变化金额',
    changeAmountHint: '正数为增加额度，负数为减少额度',
    orderNoLabel: '订单号',
    orderNoPlaceholder: '请输入订单号（可选）',
    pleaseEnterChangeAmount: '请输入变化金额',
    pleaseEnterValidNumber: '请输入有效的数字',
    fetchRecordsFailed: '获取记录失败',
    getCustomerInfoFailed: '获取客户信息失败',
    changeTypePurchase: '购买商品',
    changeTypeRefund: '退款',
    changeTypeAdjust: 'CRM调整',
    unknown: '未知',
    modifyFailed: '修改失败'
  },
  'zh-TW': {
    allCustomers: '全部',
    exclusiveCustomers: '獨占客戶',
    dealCustomers: '成單客戶',
    sharedCustomers: '共享客戶',
    afterSalesCustomers: '售後服務客戶',
    moveToMember: '移至成員',
    moveToShared: '移至共享',
    grabAsExclusive: '搶為獨占',
    searchByPhoneName: '請輸入電話、姓名或微信號',
    searchByEmployee: '請輸入員工名稱',
    search: '查詢',
    labelFilter: '標籤篩選',
    serialNumber: '序號',
    name: '姓名',
    phoneNumber: '手機號碼',
    email: '郵箱',
    wechatId: '微信號',
    inputTime: '錄入時間',
    label: '標籤',
    dealAmount: '成交金額',
    operation: '操作',
    details: '詳情',
    edit: '編輯',
    customerList: '客戶列表',
    filterLabelGroup: '篩選標籤組',
    reset: '重置',
    confirm: '確定',
    wechatChatStatistics: '與客戶企微聊天統計',
    yesterday: '昨日',
    last7Days: '近七日',
    last30Days: '近30日',
    startDate: '開始日期',
    endDate: '結束日期',
    singleChatTotal: '單聊總數',
    sentMessageCount: '發送消息數',
    sentRedPacketCount: '發送紅包數',
    sentRedPacketAmount: '發送紅包金額',
    repliedChatRatio: '已回覆聊天佔比',
    averageFirstReplyTime: '平均首次回覆時長',
    createTime: '創建時間',
    enterprise: '企業',
    description: '描述',
    source: '來源',
    mallSection: '商城版塊',
    appointmentSection: '預約版塊',
    dynamicSection: '動態版塊',
    uploadImage: '上傳圖片',
    uploadTip: '上傳圖片的最佳尺寸：690*300像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M，最少上傳1張最多可上傳直播6張',
    save: '保存',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    settingSuccess: '設置成功',
    customerName: '客戶姓名',
    customerPhone: '客戶電話',
    customerEmail: '客戶郵箱',
    customerAddress: '客戶地址',
    customerStatus: '客戶狀態',
    customerSource: '客戶來源',
    customerLevel: '客戶等級',
    addCustomer: '添加客戶',
    editCustomer: '編輯客戶',
    deleteCustomer: '刪除客戶',
    searchCustomer: '搜索客戶',
    exportCustomer: '導出客戶',
    importCustomer: '導入客戶',
    name: '姓名',
    phone: '手機號',
    wechat: '微信號',
    companyWechat: '企業微信',
    email: '郵箱',
    position: '職位',
    company: '公司',
    remark: '備註',
    tags: '標籤',
    addTag: '添加標籤',
    editTag: '編輯標籤',
    addTagGroup: '添加標籤組',
    editTagGroup: '編輯標籤組',
    tagGroupName: '標籤組名稱',
    subTag: '子標籤',
    addSubTag: '添加子標籤',
    addTagGroupBtn: '添加標籤組',
    reset: '重置',
    confirm: '確定',
    cancel: '取消',
    delete: '刪除',
    save: '保存',
    inputName: '請輸入姓名',
    inputPhone: '請輸入手機或座機號碼',
    inputWechat: '請輸入微信號',
    inputCompanyWechat: '請輸入企業微信',
    inputEmail: '請輸入郵箱',
    inputPosition: '請輸入職位',
    inputCompany: '請輸入公司名稱',
    inputRemark: '請輸入備註',
    inputTagGroupName: '請輸入標籤組名稱',
    inputSubTag: '請輸入子標籤',
    sharedScope: '共享範圍',
    exclusive: '自己獨佔',
    enterpriseShared: '企業共享',
    noPermissionEdit: '無權編輯',
    maxTagsWarning: '標籤最多添加八個',
    maxTagGroupsWarning: '標籤組最多添加三個',
    operationSuccess: '操作成功',
    pleaseEnterCustomerName: '請填寫客戶姓名',
    pleaseEnterCorrectPhone: '請填寫正確的電話號碼',
    pleaseEnterCorrectEmail: '請填寫正確的郵箱',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    employeeCannotBeCustomer: '該用戶是本公司的員工，不能添加為客戶',
    customerOccupiedByMember: '該客戶已被成員',
    contactForExclusive: '獨佔，請與他取得聯繫',
    customerExistsInPool: '共享客戶池已存在該客戶，前去搶為獨佔',
    tip: '提示',
    ok: '確定',
    customerAlreadyExclusive: '該客戶已被您獨佔',
    noPermissionModify: '無權修改',
    moveToMember: '移至成員',
    moveToShared: '移至共享',
    grabAsExclusive: '搶為獨占',
    search: '查詢',
    tagFilter: '標籤篩選',
    details: '詳情',
    edit: '編輯',
    serialNumber: '序號',
    customerName: '客戶姓名',
    mobileNumber: '手機號碼',
    email: '郵箱',
    wechatId: '微信號',
    inputTime: '錄入時間',
    tags: '標籤',
    dealAmount: '成交金額',
    operation: '操作',
    inputPhoneNameWechat: '請輸入電話、姓名或微信號',
    inputEmployeeName: '請輸入員工名稱',
    moveToSharedConfirm: '此操作會將客戶移至共享池',
    confirmGrabAsExclusive: '是否搶為獨占？',
    tip: '提示',
    confirm: '確定',
    cancel: '取消',
    transferSuccess: '移交成功',
    pleaseSelectTransferMember: '請先選擇移交的成員',
    syncQywxCustomer: '同步企微客戶',
    followUpOverview: '跟進概況',
    people: '人',
    todayNeedFollowUp: '今日需跟進數',
    todayNeedFollowUpTip: '創建時間在一周之前並且沒有成交金額的客戶數，並且在最近一周都沒有跟進記錄的客戶數。',
    accumulated7DaysNoFollow: '（累計7天未跟進）',
    todayFollowedUp: '今日已跟進數',
    todayNotFollowedUp: '今日未跟進數',
    todayNotFollowedUpTip: '屬於獨占客戶，當天沒有跟進並且沒有成交金額的客戶數。',
    dataAnalysis: '數據分析',
    today: '今日',
    last7Days: '近七天',
    last30Days: '近三十天',
    startDate: '開始日期',
    endDate: '結束日期',
    totalFollowCustomers: '累計跟客戶數',
    totalFollowCount: '累計跟進次數',
    customerFollowUpRate: '客戶跟進率',
    customerFollowUpRateTip: '今日已跟進數 / 今日需跟進數。',
    memberFollowUpList: '成員跟進列表',
    customerFollowUpList: '客戶跟進列表',
    employeeName: '姓名',
    phone: '電話',
    exclusiveCustomerCount: '獨占客戶數',
    dealCustomerCount: '成單客戶數',
    totalDealAmount: '總成交金額',
    customerTotalFollowCount: '客戶總跟進次數',
    customerFollowUpRate7Days: '7日客戶跟進率',
    todayNeedFollowUpCount: '今日需跟進數',
    todayFollowedUpCount: '今日已跟進數',
    todayNotFollowedUpCount: '今日未跟進數',
    details: '詳情',
    inputTime: '錄入時間',
    dealAmount: '成交金額',
    followCount: '跟進次數',
    lastFollowTime: '最後一次跟進時間',
    followPerson: '跟進人',
    followContent: '跟進內容',
    operation: '操作',
    search: '搜索',
    reset: '重置',
    pleaseEnterMemberNamePhone: '請輸入成員姓名或電話',
    pleaseEnterPhoneNameWechat: '請輸入電話、姓名或微信號',
    pleaseSelectFollowType: '請選擇跟進類型',
    all: '全部',
    todayNeedFollowUpType: '今日需跟進',
    todayFollowedUpType: '今日已跟進',
    todayNotFollowedUpType: '今日未跟進',
    notFollowedUp: '未跟進',
    warning: '警告',
    pleaseSelectTransferMember: '請先選擇移交的成員',
    transferSuccess: '移交成功',
    confirmGrabAsExclusive: '是否搶為獨占？',
    prompt: '提示',
    confirm: '確定',
    cancel: '取消',
    edit: '編輯',
    remark: '備註',
    remarkPlaceholder: '這裡是備註內容',
    followUpRecord: '跟進記錄',
    viewMore: '查看更多',
    pleaseSelectFollowUpMethod: '請選擇跟進方式：',
    phoneVisit: '電話拜訪',
    wechatVisit: '微信拜訪',
    manualAdd: '手動添加',
    faceToFaceVisit: '當面拜訪',
    otherMethod: '其他方式',
    pleaseEnterFollowUpRecord: '請輸入跟進記錄',
    save: '保存',
    afterSalesRecord: '售後記錄',
    afterSalesPersonnel: '售後服務人員：',
    transferAfterSales: '轉移售後',
    set: '設置',
    dealRecord: '成交記錄',
    enterDealAmount: '錄入成交金額',
    pleaseEnterAmount: '請輸入金額',
    pleaseEnterRemark: '請輸入備註',
    uploadImage: '上傳圖片',
    add: '添加',
    dealAmount: '成交金額',
    submitTime: '提交時間',
    submitPerson: '提交人',
    transactionAmount: '交易金額',
    remark: '備註',
    viewMore: '查看更多',
    customerWechatData: '客戶企微數據',
    wechatName: '企微姓名',
    wechatCompany: '企微企業',
    wechatPosition: '企微職位',
    wechatRemark: '企微備註',
    remarkCompanyName: '備註-公司名',
    remarkMobile: '備註-手機號碼',
    remarkDescription: '備註-描述',
    remarkTags: '備註-標籤',
    type: '類型',
    wechatUser: '微信用戶',
    enterpriseWechatUser: '企業微信用戶',
    source: '來源',
    addTime: '添加時間',
    unknownSource: '未知來源',
    scanQRCode: '掃描二維碼',
    searchMobile: '搜索手機號',
    businessCardShare: '名片分享',
    groupChat: '群聊',
    mobileContacts: '手機通訊錄',
    wechatContacts: '微信聯繫人',
    autoAddThirdPartyApp: '安裝第三方應用時自動添加',
    searchEmail: '搜索郵箱',
    videoAccount: '視頻號',
    scheduleParticipant: '日程參與人',
    meetingParticipant: '會議參與人',
    wechatFriendCorresponding: '微信好友對應的企業微信',
    smartHardwareExclusive: '智慧硬件專屬客服',
    internalMemberSharing: '內部成員共享',
    adminManagerAssignment: '管理員/負責人分配',
    visitBusinessCard: '訪問名片',
    manualAdd: '手動添加',
    referral: '轉介紹',
    pendingReturnVisitImport: '待回訪區導入',
    enterpriseWechat: '企業微信',
    moveToMember: '移至成員',
    grabAsExclusive: '搶為獨占',
    moveToShared: '移至共享',
    transferToSharedPool: '此操作會將客戶移至共享池',
    moveToSharedPoolTip: '此操作會將客戶移至共享池',
    confirmGrabAsExclusive: '是否搶為獨占？',
    exclusiveSuccess: '獨占成功',
    pleaseSelectMember: '請先選擇成員',
    transferSuccess: '移交成功',
    pleaseEnterValidAmount: '請輸入有效金額',
    addSuccess: '添加成功',
    deleteSuccess: '刪除成功',
    uploadLimitWarning: '最多只可上傳九張圖片！',
    pleaseEnterCorrectAmount: '請輸入正確的金額',
    pleaseEnterFollowUpRecord: '請先輸入跟進記錄',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    pleaseEnterAfterSalesRecord: '請輸入售後/服務記錄',
    noContentToSave: '沒有可保存的內容！',
    saveSuccess: '保存成功',
    noPermissionModifyAfterSales: '無權修改該客戶的售後信息',
    pleaseEnterAmount: '請輸入金額',
    pleaseEnterRemark: '請輸入備註',
    pleaseEnterFollowUpRecord: '請輸入跟進記錄',
    myFollowUpAnalysis: '我的跟進分析',
    enterpriseFollowUpAnalysis: '企業跟進分析',
    selectAfterSales: '選擇售後',
    memberName: '成員名字',
    visitCount: '訪問次數',
    inputCount: '輸入次數',
    customerAcquisitionArticle: '獲客文章',
    poster: '海報',
    distribution: '分銷',
    batchImportData: '批量導入數據',
    pleaseEnterEmployeeName: '請輸入員工名稱',
    importData: '導入數據',
    export: '導出',
    inputCustomer: '錄入客戶',
    creditRecordTitle: '信用額度變動記錄',
    viewCreditRecord: '查看信用記錄',
    creditRecordPageTip: '點擊按鈕查看客戶信用額度記錄',
    userName: '姓名',
    customerInfoLabelRemainingCredit: '信用額度余额',
    modifyCreditTitle: '修改信用額度',
    buttonModifyCredit: '修改額度',
    tableTime: '時間',
    tableType: '類型',
    tableChangeAmount: '變動金額',
    tableBalanceBefore: '變動前餘額',
    tableBalanceAfter: '變動後餘額',
    tableRelatedOrder: '關聯訂單',
    tableRemark: '備註',
    changeAmountLabel: '變化金額',
    changeAmountHint: '正數為增加額度，負數為減少額度',
    orderNoLabel: '訂單號',
    orderNoPlaceholder: '請輸入訂單號（可選）',
    pleaseEnterChangeAmount: '請輸入變化金額',
    pleaseEnterValidNumber: '請輸入有效的數字',
    fetchRecordsFailed: '獲取記錄失敗',
    getCustomerInfoFailed: '獲取客戶信息失敗',
    changeTypePurchase: '購買商品',
    changeTypeRefund: '退款',
    changeTypeAdjust: 'CRM調整',
    unknown: '未知',
    modifyFailed: '修改失敗'
  },
  'en': {
    allCustomers: 'All',
    exclusiveCustomers: 'Exclusive',
    dealCustomers: 'Deal',
    sharedCustomers: 'Shared',
    afterSalesCustomers: 'After-Sales',
    moveToMember: 'Move Member',
    moveToShared: 'Move Shared',
    grabAsExclusive: 'Grab Exclusive',
    searchByPhoneName: 'Please enter phone, name or WeChat ID',
    searchByEmployee: 'Please enter employee name',
    search: 'Search',
    labelFilter: 'Label Filter',
    serialNumber: 'No.',
    name: 'Name',
    phoneNumber: 'Mobile',
    email: 'Email',
    wechatId: 'WeChat',
    inputTime: 'Input Time',
    label: 'Label',
    dealAmount: 'Deal Amount',
    operation: 'Operation',
    details: 'Details',
    edit: 'Edit',
    customerList: 'Customer List',
    filterLabelGroup: 'Filter Label Group',
    reset: 'Reset',
    confirm: 'Confirm',
    wechatChatStatistics: 'WeChat Chat Statistics with Customer',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    startDate: 'Start Date',
    endDate: 'End Date',
    singleChatTotal: 'Single Chat Total',
    sentMessageCount: 'Sent Message Count',
    sentRedPacketCount: 'Sent Red Packet Count',
    sentRedPacketAmount: 'Sent Red Packet Amount',
    repliedChatRatio: 'Replied Chat Ratio',
    averageFirstReplyTime: 'Average First Reply Time',
    createTime: 'Create Time',
    enterprise: 'Enterprise',
    description: 'Description',
    source: 'Source',
    mallSection: 'Mall Section',
    appointmentSection: 'Appointment Section',
    dynamicSection: 'Dynamic Section',
    uploadImage: 'Upload Image',
    uploadTip: 'Best image size: 690*300 pixels. Other sizes may affect page display. Formats: png, jpeg, jpg. Size limit: 2M. Minimum 1 image, maximum 6 images.',
    save: 'Save',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload Successful',
    settingSuccess: 'Setting Successful',
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    customerEmail: 'Customer Email',
    customerAddress: 'Customer Address',
    customerStatus: 'Customer Status',
    customerSource: 'Customer Source',
    customerLevel: 'Customer Level',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    deleteCustomer: 'Delete Customer',
    searchCustomer: 'Search Customer',
    exportCustomer: 'Export Customer',
    importCustomer: 'Import Customer',
    name: 'Name',
    phone: 'Phone',
    wechat: 'WeChat',
    companyWechat: 'Company WeChat',
    email: 'Email',
    position: 'Position',
    company: 'Company',
    remark: 'Remark',
    tags: 'Tags',
    addTag: 'Add Tag',
    editTag: 'Edit Tag',
    addTagGroup: 'Add Tag Group',
    editTagGroup: 'Edit Tag Group',
    tagGroupName: 'Tag Group Name',
    subTag: 'Sub Tag',
    addSubTag: 'Add Sub Tag',
    addTagGroupBtn: 'Add Tag Group',
    reset: 'Reset',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    inputName: 'Please enter name',
    inputPhone: 'Please enter phone or landline number',
    inputWechat: 'Please enter WeChat ID',
    inputCompanyWechat: 'Please enter company WeChat',
    inputEmail: 'Please enter email',
    inputPosition: 'Please enter position',
    inputCompany: 'Please enter company name',
    inputRemark: 'Please enter remark',
    inputTagGroupName: 'Please enter tag group name',
    inputSubTag: 'Please enter sub tag',
    sharedScope: 'Shared Scope',
    exclusive: 'Exclusive to Self',
    enterpriseShared: 'Enterprise Shared',
    noPermissionEdit: 'No Permission to Edit',
    maxTagsWarning: 'Maximum 8 tags allowed',
    maxTagGroupsWarning: 'Maximum 3 tag groups allowed',
    operationSuccess: 'Operation Successful',
    pleaseEnterCustomerName: 'Please enter customer name',
    pleaseEnterCorrectPhone: 'Please enter correct phone number',
    pleaseEnterCorrectEmail: 'Please enter correct email',
    modifySuccess: 'Modified Successfully',
    addSuccess: 'Added Successfully',
    employeeCannotBeCustomer: 'This user is an employee of our company and cannot be added as a customer',
    customerOccupiedByMember: 'This customer has been occupied by member',
    contactForExclusive: 'exclusive, please contact them',
    customerExistsInPool: 'This customer already exists in the shared customer pool, go to claim as exclusive',
    tip: 'Tip',
    ok: 'OK',
    customerAlreadyExclusive: 'This customer is already exclusive to you',
    noPermissionModify: 'No Permission to Modify',
    moveToMember: 'Move Member',
    moveToShared: 'Move Shared',
    grabAsExclusive: 'Grab Exclusive',
    search: 'Search',
    tagFilter: 'Tag Filter',
    details: 'Details',
    edit: 'Edit',
    serialNumber: 'No.',
    customerName: 'Customer Name',
    mobileNumber: 'Mobile',
    email: 'Email',
    wechatId: 'WeChat',
    inputTime: 'Input Time',
    tags: 'Tags',
    dealAmount: 'Deal Amount',
    operation: 'Operation',
    inputPhoneNameWechat: 'Enter phone, name or WeChat',
    inputEmployeeName: 'Enter employee name',
    moveToSharedConfirm: 'Move customer to shared pool?',
    confirmGrabAsExclusive: 'Confirm grab as exclusive?',
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',
    transferSuccess: 'Transfer Success',
    pleaseSelectTransferMember: 'Select transfer member first',
    syncQywxCustomer: 'Sync QYWX Customer',
    followUpOverview: 'Follow-up Overview',
    people: 'People',
    todayNeedFollowUp: 'Today Need Follow-up',
    todayNeedFollowUpTip: 'Number of customers created more than a week ago with no deal amount and no follow-up records in the past week.',
    accumulated7DaysNoFollow: '(Accumulated 7 days no follow-up)',
    todayFollowedUp: 'Today Followed Up',
    todayNotFollowedUp: 'Today Not Followed Up',
    todayNotFollowedUpTip: 'Exclusive customers with no follow-up and no deal amount on the same day.',
    dataAnalysis: 'Data Analysis',
    today: 'Today',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    startDate: 'Start Date',
    endDate: 'End Date',
    totalFollowCustomers: 'Total Follow Customers',
    totalFollowCount: 'Total Follow Count',
    customerFollowUpRate: 'Customer Follow-up Rate',
    customerFollowUpRateTip: 'Today followed up / Today need follow-up.',
    memberFollowUpList: 'Member Follow-up List',
    customerFollowUpList: 'Customer Follow-up List',
    employeeName: 'Name',
    phone: 'Phone',
    exclusiveCustomerCount: 'Exclusive Customer Count',
    dealCustomerCount: 'Deal Customer Count',
    totalDealAmount: 'Total Deal Amount',
    customerTotalFollowCount: 'Customer Total Follow Count',
    customerFollowUpRate7Days: '7-Day Customer Follow-up Rate',
    todayNeedFollowUpCount: 'Today Need Follow-up Count',
    todayFollowedUpCount: 'Today Followed Up Count',
    todayNotFollowedUpCount: 'Today Not Followed Up Count',
    details: 'Details',
    inputTime: 'Input Time',
    dealAmount: 'Deal Amount',
    followCount: 'Follow Count',
    lastFollowTime: 'Last Follow Time',
    followPerson: 'Follow Person',
    followContent: 'Follow Content',
    operation: 'Operation',
    search: 'Search',
    reset: 'Reset',
    pleaseEnterMemberNamePhone: 'Please enter member name or phone',
    pleaseEnterPhoneNameWechat: 'Please enter phone, name or WeChat',
    pleaseSelectFollowType: 'Please select follow-up type',
    all: 'All',
    todayNeedFollowUpType: 'Today Need Follow-up',
    todayFollowedUpType: 'Today Followed Up',
    todayNotFollowedUpType: 'Today Not Followed Up',
    notFollowedUp: 'Not Followed Up',
    warning: 'Warning',
    pleaseSelectTransferMember: 'Please select transfer member first',
    transferSuccess: 'Transfer Success',
    confirmGrabAsExclusive: 'Confirm grab as exclusive?',
    prompt: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    edit: 'Edit',
    remark: 'Remark',
    remarkPlaceholder: 'This is the remark content',
    followUpRecord: 'Follow-up Record',
    viewMore: 'View More',
    pleaseSelectFollowUpMethod: 'Please select follow-up method:',
    phoneVisit: 'Phone Visit',
    wechatVisit: 'WeChat Visit',
    manualAdd: 'Manual Add',
    faceToFaceVisit: 'Face to Face Visit',
    otherMethod: 'Other Method',
    pleaseEnterFollowUpRecord: 'Please enter follow-up record',
    save: 'Save',
    afterSalesRecord: 'After-sales Record',
    afterSalesPersonnel: 'After-sales Service Personnel:',
    transferAfterSales: 'Transfer After-sales',
    set: 'Set',
    dealRecord: 'Deal Record',
    enterDealAmount: 'Enter Deal Amount',
    pleaseEnterAmount: 'Please enter amount',
    pleaseEnterRemark: 'Please enter remark',
    uploadImage: 'Upload Image',
    add: 'Add',
    dealAmount: 'Deal Amount',
    submitTime: 'Submit Time',
    submitPerson: 'Submit Person',
    transactionAmount: 'Transaction Amount',
    remark: 'Remark',
    viewMore: 'View More',
    customerWechatData: 'Customer WeChat Data',
    wechatName: 'WeChat Name',
    wechatCompany: 'WeChat Company',
    wechatPosition: 'WeChat Position',
    wechatRemark: 'WeChat Remark',
    remarkCompanyName: 'Remark - Company Name',
    remarkMobile: 'Remark - Mobile Number',
    remarkDescription: 'Remark - Description',
    remarkTags: 'Remark - Tags',
    type: 'Type',
    wechatUser: 'WeChat User',
    enterpriseWechatUser: 'Enterprise WeChat User',
    source: 'Source',
    addTime: 'Add Time',
    unknownSource: 'Unknown Source',
    scanQRCode: 'Scan QR Code',
    searchMobile: 'Search Mobile',
    businessCardShare: 'Business Card Share',
    groupChat: 'Group Chat',
    mobileContacts: 'Mobile Contacts',
    wechatContacts: 'WeChat Contacts',
    autoAddThirdPartyApp: 'Auto Add Third Party App',
    searchEmail: 'Search Email',
    videoAccount: 'Video Account',
    scheduleParticipant: 'Schedule Participant',
    meetingParticipant: 'Meeting Participant',
    wechatFriendCorresponding: 'WeChat Friend Corresponding',
    smartHardwareExclusive: 'Smart Hardware Exclusive',
    internalMemberSharing: 'Internal Member Sharing',
    adminManagerAssignment: 'Admin/Manager Assignment',
    visitBusinessCard: 'Visit Business Card',
    manualAdd: 'Manual Add',
    referral: 'Referral',
    pendingReturnVisitImport: 'Pending Return Visit Import',
    enterpriseWechat: 'Enterprise WeChat',
    moveToMember: 'Move to Member',
    grabAsExclusive: 'Grab as Exclusive',
    moveToShared: 'Move to Shared',
    transferToSharedPool: 'This operation will move the customer to the shared pool',
    moveToSharedPoolTip: 'This operation will move the customer to the shared pool',
    confirmGrabAsExclusive: 'Confirm grab as exclusive?',
    exclusiveSuccess: 'Exclusive Success',
    pleaseSelectMember: 'Please select member first',
    transferSuccess: 'Transfer Success',
    pleaseEnterValidAmount: 'Please enter valid amount',
    addSuccess: 'Add Success',
    deleteSuccess: 'Delete Success',
    uploadLimitWarning: 'Maximum 9 images can be uploaded!',
    pleaseEnterCorrectAmount: 'Please enter correct amount',
    pleaseEnterFollowUpRecord: 'Please enter follow-up record first',
    uploading: 'Uploading',
    uploadSuccess: 'Upload Success',
    pleaseEnterAfterSalesRecord: 'Please enter after-sales/service record',
    noContentToSave: 'No content to save!',
    saveSuccess: 'Save Success',
    noPermissionModifyAfterSales: 'No permission to modify after-sales information',
    pleaseEnterAmount: 'Please enter amount',
    pleaseEnterRemark: 'Please enter remark',
    pleaseEnterFollowUpRecord: 'Please enter follow-up record',
    myFollowUpAnalysis: 'My Follow-up Analysis',
    enterpriseFollowUpAnalysis: 'Enterprise Follow-up Analysis',
    selectAfterSales: 'Select After-sales',
    memberName: 'Member Name',
    visitCount: 'Visit Count',
    inputCount: 'Input Count',
    customerAcquisitionArticle: 'Customer Acquisition Article',
    poster: 'Poster',
    distribution: 'Distribution',
    batchImportData: 'Batch Import Data',
    pleaseEnterEmployeeName: 'Please enter employee name',
    importData: 'Import Data',
    export: 'Export',
    inputCustomer: 'Input Customer',
    creditRecordTitle: 'Credit Limit Change Records',
    viewCreditRecord: 'View Credit Record',
    creditRecordPageTip: 'Click button to view customer credit record',
    userName: 'Name',
    customerInfoLabelRemainingCredit: 'Credit Balance',
    modifyCreditTitle: 'Modify Credit Limit',
    buttonModifyCredit: 'Modify Limit',
    tableTime: 'Time',
    tableType: 'Type',
    tableChangeAmount: 'Change Amount',
    tableBalanceBefore: 'Balance Before',
    tableBalanceAfter: 'Balance After',
    tableRelatedOrder: 'Related Order',
    tableRemark: 'Remark',
    changeAmountLabel: 'Change Amount',
    changeAmountHint: 'Positive increases credit, negative decreases credit',
    orderNoLabel: 'Order No.',
    orderNoPlaceholder: 'Enter order number (optional)',
    pleaseEnterChangeAmount: 'Please enter change amount',
    pleaseEnterValidNumber: 'Please enter a valid number',
    fetchRecordsFailed: 'Failed to fetch records',
    getCustomerInfoFailed: 'Failed to get customer info',
    changeTypePurchase: 'Purchase',
    changeTypeRefund: 'Refund',
    changeTypeAdjust: 'CRM Adjustment',
    unknown: 'Unknown',
    modifyFailed: 'Modify failed'
  }
};